import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  // const [consentGiven, setConsentGiven] = useState(null); // 향후 사용 예정

  useEffect(() => {
    // 이전 동의 여부 확인
    const savedConsent = localStorage.getItem('cookieConsent');
    if (!savedConsent) {
      setShowBanner(true);
    }
    // else {
    //   setConsentGiven(savedConsent === 'true'); // 향후 사용 예정
    // }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    // setConsentGiven(true); // 향후 사용 예정
    setShowBanner(false);

    // Google AdSense 동의 신호 전송
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    // setConsentGiven(false); // 향후 사용 예정
    setShowBanner(false);

    // Google AdSense 거부 신호 전송
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#fff',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      padding: '20px',
      zIndex: 10000,
      borderTop: '3px solid #8B4513'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
        <div style={{ flex: 1, minWidth: '300px' }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#8B4513' }}>
            🍪 쿠키 및 개인정보 이용 동의
          </h4>
          <p style={{ margin: 0, fontSize: '14px', color: '#666', lineHeight: '1.4' }}>
            도토리 저금통은 서비스 개선과 맞춤형 광고 제공을 위해 쿠키와 유사 기술을 사용합니다.
            계속 이용하시면 <a href="/privacy" style={{ color: '#8B4513' }}>개인정보처리방침</a> 및
            <a href="/terms" style={{ color: '#8B4513' }}>이용약관</a>에 동의하는 것으로 간주됩니다.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            onClick={handleDecline}
            style={{
              padding: '10px 20px',
              border: '2px solid #8B4513',
              backgroundColor: 'transparent',
              color: '#8B4513',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            필수만 허용
          </button>
          <button
            onClick={handleAccept}
            style={{
              padding: '10px 20px',
              border: 'none',
              backgroundColor: '#8B4513',
              color: 'white',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            모두 동의
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;